import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const FlagSoloPendientesFormGroup = ({ fIsSubmitting, iValue }) => {
  return (
    <Form.Group>
      <Form.Label text='' htmlFor='checkbox-flagSoloPendientes' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='flagSoloPendientes'>
          {({ field }) => (
            <Form.Checkbox
              {...field}
              checked={iValue}
              disabled={fIsSubmitting}
              id='checkbox-flagSoloPendientes'
              label='Listar solo pendientes'
            />
          )}
        </Field>
      </Col>
    </Form.Group>
  )
}

export default React.memo(FlagSoloPendientesFormGroup)
